<template>
    <li id="post-list-item-small" class="clearfix">
        <div class="post-block-style post-float clearfix">
            <div class="post-thumb">
                <a :href="data.post_url">
                    <img class="img-fluid" :src="resizedThumbnail(data.thumbnail, 60)" :alt="data.title">
                </a>
            </div><!-- Post thumb end -->

            <div class="post-content">
                <h2 class="post-title title-small">
                    <a :href="data.post_url" v-html="data.title"></a>
                </h2>
                <div class="post-meta">
                    <span class="post-date">{{ data.creation_date | formatShortDate }}</span>
                </div>
            </div><!-- Post content end -->
        </div><!-- Post block style end -->
    </li>
</template>

<script>
    import { resizedThumbnail } from "../../helpers/helpers";

    export default {
        name: 'PostListItemSmall',
        props: ['data'],
        methods: {
            resizedThumbnail(url, height) {
                return resizedThumbnail(url, height);
            }
        }
    }
</script>

<style lang="scss">
    @import '~@/absctracts/variables.scss';
    @import '~@/absctracts/mixins.scss';

    #post-list-item-small {
        margin-bottom: 15px;
        max-height: 75px;
        padding-right: 22px;

        .post-block-style {
            overflow: hidden;
            position: relative;

            .post-thumb {
                float: left;
                margin-right: 20px;
                position: relative;
                z-index: 1;

                img {
                    max-width: 100px;
                    height: 60px;
                    max-height: 65px;
                    object-fit: cover;
                    -webkit-transition: all .3s ease-out;
                    -o-transition: all .3s ease-out;
                    transition: all .3s ease-out;
                }

                img:hover {
                    @include imgHoverScale(1.15);
                }

            }

            .post-content {
                z-index: 0;
                padding: 0px;

                .post-title {
                    margin-top: -4px;
                    font-size: 14px;
                    line-height: 20px;
                    margin-bottom: 5px;
                    height: 39px;
                    max-height: 56px;
                    overflow: hidden;

                    a {
                        color: $dark-grey;
                    }

                    a:hover {
                        color: $red;
                    }
                }

                .post-meta {
                    margin: 3px 0;

                    span {
                        font-size: 12px;
                        color: #a3a3a3;
                        margin-right: 8px;
                        padding-right: 10px;
                        line-height: 12px;
                        display: inline-block;

                        .post-date {
                            border-right: 0;
                        }
                    }
                }
            }
        }
    }
</style>